export default () => ({
  terms: []
});
